import { apiSlice } from "./apiSlice/apiSlice";

/**
 * Redux action for a company data-reset WebSocket envelope.
 *
 * @const {string}
 */
export const DATA_RESET_EVENT = "dataReset/event";

/**
 * Apply a data_reset envelope to RTK Query cache.
 *
 * Snapshot replaces. Patch merges. An orphan patch (no cache yet) refetches
 * GET current so a late tab gets a full snapshot.
 *
 * @param {{
 *   api: {endpoints: Object, util: Object},
 * }} options
 * @return {function(Object): function(function(*): *): function(*): *}
 */
export const createDataResetMiddleware = ({ api }) => store => next => action => {
  const result = next(action);
  if (action.type === DATA_RESET_EVENT) {
    const envelope = action.payload;
    if (envelope?.type !== "data_reset") return result;
    const payload = envelope.payload;
    const mode = envelope.mode;
    const endpoint = api.endpoints.getDataResetCurrent;
    if (!endpoint) return result;
    const current = endpoint.select(undefined)(store.getState());
    if (mode === "snapshot" && payload) {
      // Cache or reuse: write WS payload into RTK instead of another GET.
      store.dispatch(api.util.updateQueryData("getDataResetCurrent", undefined, () => payload));
    } else if (mode === "patch") {
      if (!current?.data) {
        // Fetch less: one snapshot GET, then wait for later patches.
        store.dispatch(endpoint.initiate(undefined, { forceRefetch: true }));
      } else {
        store.dispatch(
          api.util.updateQueryData("getDataResetCurrent", undefined, draft => {
            Object.assign(draft, payload);
          }),
        );
      }
    }
  }
  // Reconnect catch-up — do work later, not on a timer.
  if (action.type === "resourceSync/connected") {
    const auth = store.getState().auth;
    if (auth?.isAuthenticated && auth.user && api.endpoints.getDataResetCurrent) {
      store.dispatch(
        api.endpoints.getDataResetCurrent.initiate(undefined, { forceRefetch: true }),
      );
    }
  }
  return result;
};

/**
 * Default middleware bound to the shared API slice.
 *
 * @const
 */
export const dataResetMiddleware = createDataResetMiddleware({ api: apiSlice });
